import React, { useState, useEffect, Fragment } from 'react';
import { Link } from 'react-router-dom';
import CardContainer from '../../components/card/card-container.jsx';
import LinkDownload from '../../components/link/link-download';
import LabelCategory from '../../components/label/label-category.jsx';
import Api from '../../api/global.service';
import { useAuth } from '../../components/content/auth.jsx';
import { useCoopConfig } from '../../components/content/coop-config.jsx';
import env from '../../environment.js';
import NoPagination from '../../components/pagination/noPagination.jsx';
import SelectCiclo from '../../components/select/select-ciclo.jsx';
import SearchColumn from '../../components/search/search-column.jsx';
import ListToolbar, { BtnNuevo, BtnCancelar } from '../../nuup/componentes/Toolbar/ListToolbar.jsx';
import Swal from 'sweetalert2';
import ModalPadronAltasBajas from '../../components/modal/modal-padron-altas-bajas.jsx';
import ModalPadronAltasBajasCancelar from '../../components/modal/modal-padron-altas-bajas-cancelar.jsx';
import ModalPadron from '../../components/modal/modal-padron.jsx';
import EditLink from '../../components/link/edit-link.jsx';
import CheckboxList from '../../components/forms/checkbox-list.jsx';
import getColor from '../../utils/getColor.js';
import TabButtons from '../../components/link/tab-buttons.jsx';

const PadronAltasList = () => {
  const auth = useAuth();
  const coopConfig = useCoopConfig();
  const [data, setData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [ciclo, setCiclo] = useState({});
  const [blocking, setBlocking] = useState(true);
  const [btnPendientes, setBtnPendientes] = useState(true);
  const [idsSeleccionados, setIdsSeleccionados] = useState([]);
  const [confirmAltas, setConfirmAltas] = useState(false);
  const [edit, setEdit] = useState(null);
  const dialog = React.createRef();
  const dialogEdit = React.createRef();
  const dialogDelete = React.createRef();
  const report = 'padron_altas';

  const handleCheck = event => {
    let prodSel = idsSeleccionados;
    if (event.target.checked === true) {
      setIdsSeleccionados([...prodSel, event.target.value]);
    } else {
      prodSel = prodSel.filter(item => item !== event.target.value);
      setIdsSeleccionados(prodSel);
    }
  };

  const onClickEdit = (event, data) => {
    event.preventDefault();
    setEdit(data);
  };

  const columns = [
    {
      Header: 'INFORMACIÓN DE PRODUCTOR',
      columns: [
        {
          Header: '-',
          accessor: false,
          sortable: false,
          width: 25,
          Cell: ({ row, value }) => {
            return (
              <>
                <div className="form-check">
                  {parseInt(row.original.confirmado) === 0 && (
                    <CheckboxList
                      name="productores"
                      value={row.original.uuid_cuentas_altas_solicitud}
                      handleCheck={handleCheck}
                      checked={idsSeleccionados.includes(row.original.uuid_cuentas_altas_solicitud)}
                    />
                  )}
                  <label className="form-check-label" htmlFor="flexCheckChecked" style={{ marginTop: 5, paddingLeft: 5 }}>
                    {value}
                  </label>
                </div>
              </>
            );
          },
        },
        {
          Header: 'CLAVE',
          accessor: 'productor_clave_tx',
          sortable: true,
          minWidth: 50,
          Cell: ({ row, value }) => {
            const editData = {
              type: 'text',
              accessor: 'productor_clave_tx',
              oldValue: value,
              columnName: 'CLAVE',
              nombreProductor: row.original.productor_nombre,
              id_cuenta: row.original.id,
            };
            return (
              <EditLink onClickEdit={e => onClickEdit(e, editData)}>
                <p style={{ margin: 0 }}>{value}</p>
              </EditLink>
            );
          },
        },
        {
          Header: 'NOMBRE PRODUCTOR',
          accessor: 'productor_nombre',
          sortable: true,
          minWidth: 50,
          Cell: ({ row, value }) => (
            <Link to={{ pathname: `/admin/cuentas/perfil/${row.original.productor_uuid}` }} className="m-r-2" style={{ color: '#789D16' }}>
              <span>{value}</span>
            </Link>
          ),
        },
        {
          Header: 'LOCALIDAD',
          accessor: 'localidad',
          sortable: true,
          minWidth: 50,
        },
        {
          Header: 'REGIÓN',
          accessor: 'region',
          sortable: true,
          minWidth: 50,
        },
        {
          Header: 'MUNICIPIO',
          accessor: 'municipio',
          sortable: true,
          minWidth: 50,
        },
        {
          Header: 'CÓDIGO',
          accessor: 'productor_codigo_tx',
          sortable: true,
          minWidth: 50,
        },
        {
          Header: 'CURP',
          accessor: 'curp',
          sortable: true,
          minWidth: 50,
        },
        {
          Header: 'CATEGORÍA',
          accessor: 'cuenta_categoria',
          sortable: true,
          minWidth: 90,
          Cell: ({ row, value }) => <LabelCategory label={value} color={row.original.cuenta_categoria_color}></LabelCategory>,
        },
      ],
    },
    {
      Header: 'INFORMACIÓN PROGRAMA ORGÁNICO',
      columns: [
        {
          Header: 'FECHA INGRESO ORGÁNICO',
          accessor: 'productor_fecha_ingreso',
          sortable: true,
          minWidth: 50,
        },
        {
          Header: 'FECHA INGRESO TRANSICIÓN',
          accessor: 'productor_fecha_transicion',
          sortable: true,
          minWidth: 50,
        },
      ],
    },
  ];

  const searchColumns = React.useMemo(
    () => [
      { value: 0, target: '', label: 'TODO' },
      { value: 1, target: 'productor_clave_tx', label: 'NO' },
      { value: 2, target: 'localidad', label: 'LOCALIDAD' },
      { value: 3, target: 'region', label: 'REGIÓN' },
      { value: 5, target: 'municipio', label: 'MUNICIPIO' },
      { value: 6, target: 'productor_codigo_tx', label: 'CÓDIGO' },
      { value: 7, target: 'productor_nombre', label: 'NOMBRE PRODUCTOR' },
      { value: 8, target: 'cuenta_categoria', label: 'CATEGORÍA' },
      { value: 9, target: 'productor_fecha_ingreso', label: 'FECHA INGRESO ORGÁNICO' },
      { value: 10, target: 'productor_fecha_transicion', label: 'FECHA INGRESO TRANSICIÓN' },
    ],
    []
  );

  const getData = () => {
    setBlocking(true);
    Api.search('admin/sic/padron_altas', {
      filter: [
        { column: 'id_ciclo', operator: '=', value: ciclo.id },
        { column: 'confirmado', operator: '=', value: btnPendientes ? 0 : 1 },
      ],
    })
      .then(response => {
        setData(response.data);
        setOriginalData(response.data);
        setBlocking(false);
      })
      .catch(e => {
        setBlocking(false);
      });
  };

  const setFilter = value => {
    setCiclo(value.target);
  };

  const setDataFilter = data => {
    setData(data);
  };

  const getBackgroundColor = (i, j) => {
    if (i == 1) {
      return 'rgb(247, 239, 231)';
    } else {
      switch (j) {
        // case 0: return env.colors.neutral_600; break;
        case 1:
          return '#91918A';
        // case 2: return '#C7AE34'; break;
        case 3:
          return '#91918A';
        default:
          return env.colors.neutral_600;
      }
    }
  };

  const getPendientes = () => {
    setBtnPendientes(true);
  };

  const getHistorial = () => {
    setBtnPendientes(false);
  };

  useEffect(() => {
    if (ciclo?.id) {
      getData();
    }
  }, [btnPendientes, ciclo]);

  useEffect(() => {}, [idsSeleccionados]);

  const enviarAlta = async padronesSeleccionados => {
    if (idsSeleccionados.length > 0) {
      setBlocking(true);
      let data = { ids: idsSeleccionados, id_ciclo: ciclo.id, padronesSeleccionados };
      dialog.current.close();
      // update altas
      try {
        const response = await Api.create('admin/sic/confirmar_altas', data);
        if (response.status >= 200 && response.status < 300) {
          setIdsSeleccionados([]);
          getData();
          setConfirmAltas(!confirmAltas);
          setBlocking(false);
          Swal.fire({
            icon: 'success',
            title: '',
            text: `Se ha confirmado el alta de ${idsSeleccionados.length} productores`,
          });
        }
      } catch (e) {
        setBlocking(false);
      }
      // update alerts for altas
      await coopConfig.getAlerts(ciclo.id);
    }
  };

  const cancelarAlta = async () => {
    if (idsSeleccionados.length > 0) {
      setBlocking(true);
      dialogDelete.current.close();
      let data = { ids: idsSeleccionados, id_ciclo: ciclo.id };
      // refactoriza el siguiente extracto de código para async/await Api.create
      try {
        const response = await Api.create('admin/sic/cancelar_altas', data);
        if (response.status >= 200 && response.status < 300) {
          setIdsSeleccionados([]);
          getData();
          setConfirmAltas(!confirmAltas);
          setBlocking(false);
          Swal.fire({
            icon: 'success',
            title: '',
            text: `Se ha cancelado el alta de ${idsSeleccionados.length} productores`,
          });
        }
      } catch (e) {
        setBlocking(false);
      }
      // update alerts for altas
      await coopConfig.getAlerts(ciclo.id);
    }
  };

  useEffect(() => {
    if (edit !== null) {
      dialogEdit.current.editText(edit);
    }
  }, [edit]);

  return (
    <div>
      <div className="row mb-1">
        <div className="col-4">
          <SelectCiclo
            setFilter={evt => {
              setFilter(evt);
            }}></SelectCiclo>
        </div>

        <div className="col-8 d-flex justify-content-end">
          {ciclo?.uuid && auth.hasPermission('PADRON_ALTAS_EXPORTAR') && (
            <LinkDownload url={`xls/${report}/${ciclo?.uuid}`} label="Descargar Excel" icon={env.images.icon.xls}></LinkDownload>
          )}
        </div>
      </div>

      <div className="row justify-content-between mb-2 ml-1">
        <TabButtons
          btnLeftHandle={() => getPendientes()}
          btnRightHandle={() => getHistorial()}
          btnDisabled={btnPendientes}
          btnLeftLabel="Pendientes"
          btnRightLabel="Historial"
        />
      </div>

      <CardContainer height={'100%'}>
        <ListToolbar left={<SearchColumn data={originalData} columns={searchColumns} setDataFilter={evt => setDataFilter(evt)} />}>
          <BtnNuevo
            show={btnPendientes}
            icon={null}
            disabled={idsSeleccionados.length == 0}
            onClick={() => dialog.current.open()}>
            Confirmar alta
          </BtnNuevo>
          <BtnCancelar show={btnPendientes} disabled={idsSeleccionados.length == 0} onClick={() => dialogDelete.current.open()}>
            Cancelar alta
          </BtnCancelar>
        </ListToolbar>

        <NoPagination
          blocking={blocking}
          columns={columns}
          data={data}
          fnBackgroundColor={getBackgroundColor}
          fnColor={getColor}></NoPagination>
      </CardContainer>
      <ModalPadron ref={dialogEdit} />
      <ModalPadronAltasBajas
        ref={dialog}
        type="Alta"
        title="Confirmar alta de productores"
        onConfirm={padronesSeleccionados => {
          enviarAlta(padronesSeleccionados);
        }}></ModalPadronAltasBajas>

      <ModalPadronAltasBajasCancelar
        ref={dialogDelete}
        type="altas"
        title="Cancelar alta de productores"
        onConfirm={() => {
          cancelarAlta();
        }}></ModalPadronAltasBajasCancelar>
    </div>
  );
};

export default PadronAltasList;
